import { ref, reactive, toRefs } from 'vue';
import axios from 'axios';

const User = reactive({
  userDetails: {
    userId: '',
    username: '',
    firstName: '',
    lastName: '',
    preferredFirstName: '',
    colleagueId: '',
    email: '',
    vaccinationStatus: '',
    isRA: '',
  },
});

const raNameList = ref([]);

export default function useUser() {
  const currentUserId = ref(0);

  const getUser = async (id) => {
    try {
      if (id === undefined || id === null) {
        return;
      }
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/${id}`;
      const response = await axios.get(url);
      const { data } = response;
      if (data !== undefined || data !== null) {
        User.userDetails = data;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getRaNames = async (sessionId) => {
    try {
      if (raNameList.value.length !== 0) {
        return;
      }
      if (sessionId === undefined || sessionId === null) {
        return;
      }
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/getRaNames`;
      const response = await axios.get(url, {
        params: {
          sessionId,
        },
      });
      const { data } = response;
      if (data !== undefined || data !== null) {
        for (let i = 0; i < data.data.length; i += 1) {
          raNameList.value.push({
            value: data.data[i].userId,
            label: data.data[i].fullName,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getUserNameIds = async (sessionId) => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/userNameIds`;
      const response = await axios.get(url, {
        params: {
          sessionId,
        },
      });
      const { data } = response;
      if (data !== undefined || data !== null) {
        return data.data;
      }
    } catch (error) {
      console.log(error);
    }

    return [];
  };

  const getAllUsernames = async () => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/usernames`;
      const response = await axios.get(url);
      const { data } = response;
      if (data !== undefined || data !== null) {
        return data.data;
      }
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const getUsersExport = async () => {
    try {
      const result = await axios.get(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/UsersExport`,
      );

      return result.data;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const getUserProxies = async () => {
    try {
      const result = await axios.get(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/proxies`,
      );

      return result.data;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const addOrUpdateUserProxies = async (proxies) => {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/proxies`,
        proxies,
      );

      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const updateUser = async (currentUserDetails) => {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users`,
        currentUserDetails,
      );

      return response;
    } catch (error) {
      console.log(error);

      return error.response;
    }
  };

  const updateUserRaStatus = async (currentUserDetails) => {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/updateUserRaStatus`,
        currentUserDetails,
      );

      return response;
    } catch (error) {
      console.log(error);

      return error.response;
    }
  };

  const resetCurrentUserId = () => {
    currentUserId.value = null;
  };

  const resetCurrentUser = () => {
    resetCurrentUserId();
    User.userDetails.userId = '';
    User.userDetails.username = '';
    User.userDetails.firstName = '';
    User.userDetails.lastName = '';
    User.userDetails.colleagueId = '';
    User.userDetails.email = '';
    User.userDetails.vaccinationStatus = '';
    User.userDetails.isRA = '';
  };

  const verifyVaccinations = async () => {
    try {
      const result = await axios.get(
        `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/vaccinationVerifications`,
      );
      return result.data;
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const getOipStudents = async (colleagueId = null, year = null) => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/Users/oipStudents`;
      const params = {};

      if (colleagueId) {
        params.colleagueId = colleagueId;
      }
      if (year) {
        params.year = year;
      }

      const response = await axios.get(url, { params });
      const { data } = response;

      if (data?.data) {
        // Store OIP status and SEA status for router guard
        if (data.data.length === 1 && colleagueId) {
          const student = data.data[0];
          sessionStorage.setItem('isOipStudent', 'true');
          sessionStorage.setItem('seaStatus', student.seaStatus?.toString() || 'null');
        }
        return data.data;
      }
      // Not an OIP student
      if (colleagueId) {
        sessionStorage.setItem('isOipStudent', 'false');
        sessionStorage.removeItem('seaStatus');
      }
      return null;
    } catch (error) {
      if (error.response?.status === 403 && error.response?.data?.code === 'SEA_REQUIRED') {
        sessionStorage.setItem('isOipStudent', 'true');
        sessionStorage.setItem('seaStatus', 'false');

        window.location.href = '/sea-required';
        return null;
      }

      console.log(error);
      return null;
    }
  };

  return {
    ...toRefs(User),
    currentUserId,
    addOrUpdateUserProxies,
    getRaNames,
    getUser,
    getAllUsernames,
    getUserNameIds,
    getUsersExport,
    getUserProxies,
    raNameList,
    resetCurrentUser,
    resetCurrentUserId,
    updateUser,
    updateUserRaStatus,
    verifyVaccinations,
    getOipStudents,
  };
}
